module.exports = __webpack_public_path__ + "static/media/trash.a3bbf00d.svg";